const range = (n) => Array.from({ length: n }, (_, i) => i);

export const EmployeesSidebarGhost = ({ repeat = 8 }) => (
  <div className="flex flex-col gap-2 px-1">
    {range(repeat).map((i) => (
      <div key={i} className="rounded p-3">
        <div className="flex flex-col gap-1">
          <div className="h-4 w-36 rounded bg-gray-200" />
          <div className="h-3 w-28 rounded bg-gray-200" />
        </div>
      </div>
    ))}
  </div>
);

export const SettingsQualificationsListGhost = ({ repeat = 5 }) => (
  <div className="flex flex-col gap-2">
    {range(repeat).map((i) => (
      <div
        key={i}
        className="flex w-full items-center justify-between gap-4 rounded-lg border px-4 py-3"
      >
        <div className="h-4 w-48 max-w-full rounded bg-gray-200" />
        <div className="flex shrink-0 gap-1">
          <div className="h-9 w-9 rounded-md bg-gray-200" />
          <div className="h-9 w-9 rounded-md bg-gray-200" />
        </div>
      </div>
    ))}
  </div>
);

export const SettingsSectorsListGhost = ({ repeat = 5 }) => (
  <div className="flex flex-col gap-2">
    {range(repeat).map((i) => (
      <div
        key={i}
        className="flex w-full items-center justify-between gap-4 rounded-lg border px-4 py-3"
      >
        <div className="h-4 min-w-0 w-40 rounded bg-gray-200" />
        <div className="flex shrink-0 items-center gap-6">
          <div className="h-9 w-[140px] shrink-0 rounded-lg bg-gray-200" />
          <div className="flex gap-1">
            <div className="h-9 w-9 rounded-md bg-gray-200" />
            <div className="h-9 w-9 rounded-md bg-gray-200" />
          </div>
        </div>
      </div>
    ))}
  </div>
);
